import { useState, useEffect } from "react";
import axios from "axios.js";

// react-router-dom components
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useIsAuthenticated } from "react-auth-kit";

// @mui material components
import Card from "@mui/material/Card";
// import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Authentication layout components
import BasicLayout from "app/user/components/BasicLayout";

// Images
// import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import bgImage from "assets/images/tech_bg.jpg";
import {
  Snackbar,
  Alert,
  Backdrop,
  CircularProgress,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  // DialogActions,
  Icon,
  Divider,
} from "@mui/material";

import { Formik } from "formik";
import * as Yup from "yup";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

// inital login credentials
const initialValues = {
  last_name: "",
  first_name: "",
  email: "",
  phone: "",
  password: "",
  cpassword: "",
  city: "",
  dob: "",
  address: "",
  // mobile_network: "",
};

// form field validation schema
const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, "Password must be atleast 6 character length")
    .required("Password is required!"),
  cpassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Password is required!"),
  last_name: Yup.string().required("Last name is required!"),
  first_name: Yup.string().required("First name is required!"),
  phone: Yup.string().required("Phone number is required!"),
  email: Yup.string().email("Invalid Email address").required("Email is required!"),
  dob: Yup.date().required("Birth date required!"),
  city: Yup.string().required("Home city is required!"),
  address: Yup.string().required("Home address is required!"),
  // mobile_network: Yup.string().required("Mobile network is required!"),
});

function UserSignUp() {
  const title = "Register";
  usePageTitle(title);
  const urlLocation = useLocation().search;

  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  if (isAuthenticated()) {
    navigate("/dashboard");
  }

  const [showLoading, setShowLoading] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
    setShowLoading(false);
    setSeverity("error");
  };

  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [gender, setGender] = useState(null);
  // const [mobileNetwork, setMobileNetwork] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [referralCode, setReferralCode] = useState("");
  const [acceptTC, setAcceptTC] = useState(false);

  useEffect(() => {
    if (1 == 1) {
      navigate("/sign-in");
      return;
    }
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/register/init.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCountries(result.data.data.countries);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again in a few moments.");
          setOpen(true);
        });
    };

    const rfc = new URLSearchParams(urlLocation).get("inviteCode");
    if (rfc !== null) {
      setReferralCode(rfc);
    }

    fetchData();
  }, []);

  const handleFormSubmit = async (values) => {
    if (gender === null || gender === "-") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Gender is required.");
      setSeverity("error");
      return;
    }

    // if (mobileNetwork === null) {
    //   setOpen(true);
    //   setShowLoading(false);
    //   setErrMsg("Mobile network is required.");
    //   setSeverity("error");
    //   return;
    // }

    if (selectedState === null) {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("State is required.");
      setSeverity("error");
      return;
    }

    if (selectedCountry === null) {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Currency is required.");
      setSeverity("error");
      return;
    }

    if (acceptTC !== true) {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Please accept the terms and conditions");
      setSeverity("error");
      return;
    }

    setShowLoading(true);
    try {
      const json = {
        first_name: values.first_name,
        last_name: values.last_name,
        email_address: values.email,
        phone_number: values.phone,
        password: values.password,
        dob: values.dob,
        city: values.city,
        address: values.address,
        // mobile_network: mobileNetwork,
        state: selectedState,
        gender: `${gender}`,
        country: selectedCountry,
        referral_code: referralCode,
      };
      // console.log(json);
      const response = await axios.post("agents/register.json", json);
      if (response.data.status === "error") {
        setOpen(true);
        setShowLoading(false);
        setErrMsg(response.data.data.message);
        setSeverity("error");
      } else {
        setOpen(true);
        setShowLoading(false);
        setErrMsg(response.data.data.message);
        setSeverity("success");
        // navigate("/sign-in");
        setSuccessDialog(true);
      }
    } catch (e) {
      setShowLoading(false);
      setErrMsg("An error occurred. Please try again later.");
      setSeverity("error");
      setOpen(true);
    }
  };

  useEffect(() => {
    setSelectedState(null);
    countries.every((param) => {
      if (param.reference === selectedCountry) {
        setStates(param.states);
        return false;
      }
      return true;
    });
  }, [selectedCountry]);

  return (
    <BasicLayout image={bgImage}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={successDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox align="center">Registration Success!</MDBox>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox align="center">
              <MDBox mt={2}>
                <MDButton color="success" variant="outlined" iconOnly circular>
                  <Icon color="success">check</Icon>
                </MDButton>
              </MDBox>
              <MDBox mt={5}>
                <MDButton
                  onClick={() => {
                    navigate("/sign-in");
                  }}
                  color="info"
                  variant="contained"
                >
                  <Icon>login</Icon> &nbsp; Login
                </MDButton>
              </MDBox>
            </MDBox>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <MDBox mt={5} mb={5}>
        <Card>
          {/* <MDBox
          variant="gradient"
          bgColor={AppConfig.sidenav_active_menu_color}
          borderRadius="lg"
          coloredShadow={AppConfig.sidenav_active_menu_color}
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {AppConfig.app_name}
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Sign Up
          </MDTypography>
        </MDBox> */}
          <MDBox pb={3} px={3}>
            <MDBox mb={1} p={1} align="center" mt={1}>
              <MDTypography variant="h4" fontWeight="medium" mt={1}>
                {AppConfig.app_name}
              </MDTypography>
              <MDTypography display="block" variant="button" my={1}>
                Create an account
              </MDTypography>
            </MDBox>
            <MDBox mb={5}>
              <Divider />
            </MDBox>
            <MDBox role="form">
              <Formik
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={validationSchema}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <MDBox mb={3}>
                      <MDInput
                        name="last_name"
                        type="text"
                        label="Last Name"
                        variant="outlined"
                        fullWidth
                        onBlur={handleBlur}
                        value={values.last_name}
                        onChange={handleChange}
                        helperText={touched.last_name && errors.last_name}
                        error={Boolean(errors.last_name && touched.last_name)}
                      />
                    </MDBox>
                    <MDBox mb={3}>
                      <MDInput
                        name="first_name"
                        type="text"
                        label="First Name"
                        variant="outlined"
                        fullWidth
                        onBlur={handleBlur}
                        value={values.first_name}
                        onChange={handleChange}
                        helperText={touched.first_name && errors.first_name}
                        error={Boolean(errors.first_name && touched.first_name)}
                      />
                    </MDBox>
                    <MDBox mb={3}>
                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                        <InputLabel>Gender</InputLabel>
                        <Select
                          label="Gender"
                          onChange={(e) => {
                            setGender(e.target.value);
                          }}
                          sx={{ padding: "12px", paddingLeft: "3px" }}
                        >
                          <MenuItem value="-">-</MenuItem>
                          <MenuItem value="M">Male</MenuItem>
                          <MenuItem value="F">Female</MenuItem>
                        </Select>
                      </FormControl>
                    </MDBox>
                    <MDBox mb={3}>
                      <MDInput
                        name="dob"
                        type="date"
                        label="Birth Date"
                        variant="outlined"
                        fullWidth
                        onBlur={handleBlur}
                        value={values.dob}
                        onChange={handleChange}
                        helperText={touched.dob && errors.dob}
                        error={Boolean(errors.dob && touched.dob)}
                      />
                    </MDBox>
                    <MDBox mb={3}>
                      <MDInput
                        name="email"
                        type="email"
                        label="Email"
                        variant="outlined"
                        fullWidth
                        onBlur={handleBlur}
                        value={values.email}
                        onChange={handleChange}
                        helperText={touched.email && errors.email}
                        error={Boolean(errors.email && touched.email)}
                      />
                    </MDBox>
                    <MDBox mb={3}>
                      <MDInput
                        name="phone"
                        type="text"
                        label="Phone Number"
                        variant="outlined"
                        fullWidth
                        onBlur={handleBlur}
                        value={values.phone}
                        onChange={handleChange}
                        helperText={touched.phone && errors.phone}
                        error={Boolean(errors.phone && touched.phone)}
                      />
                    </MDBox>
                    {/* <MDBox mb={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Mobile Network</InputLabel>
                      <Select
                        label="Mobile Network"
                        onChange={(e) => setMobileNetwork(e.target.value)}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        <MenuItem value="MTN">MTN</MenuItem>
                        <MenuItem value="GLO">GLO</MenuItem>
                        <MenuItem value="9MOBILE">9Mobile</MenuItem>
                        <MenuItem value="AIRTEL">Airtel</MenuItem>
                      </Select>
                    </FormControl>
                  </MDBox> */}
                    <MDBox mb={3}>
                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                        <InputLabel>Country</InputLabel>
                        <Select
                          label="Country"
                          onChange={(e) => {
                            setSelectedCountry(e.target.value);
                          }}
                          sx={{ padding: "12px", paddingLeft: "3px" }}
                        >
                          {
                            // --> Notice below changes
                            countries.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                              countries.map((record) => (
                                <MenuItem value={record.reference}>{record.title}</MenuItem>
                              ))
                          }
                        </Select>
                      </FormControl>
                    </MDBox>
                    <MDBox mb={3}>
                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                        <InputLabel>State</InputLabel>
                        <Select
                          label="State"
                          onChange={(e) => {
                            setSelectedState(e.target.value);
                          }}
                          sx={{ padding: "12px", paddingLeft: "3px" }}
                        >
                          {
                            // --> Notice below changes
                            states.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                              states.map((record) => (
                                <MenuItem value={record.reference}>{record.title}</MenuItem>
                              ))
                          }
                        </Select>
                      </FormControl>
                    </MDBox>
                    <MDBox mb={3}>
                      <MDInput
                        name="city"
                        type="city"
                        label="City"
                        variant="outlined"
                        fullWidth
                        onBlur={handleBlur}
                        value={values.city}
                        onChange={handleChange}
                        helperText={touched.city && errors.city}
                        error={Boolean(errors.city && touched.city)}
                      />
                    </MDBox>
                    <MDBox mb={3}>
                      <MDInput
                        name="address"
                        type="address"
                        label="Address"
                        variant="outlined"
                        fullWidth
                        onBlur={handleBlur}
                        value={values.address}
                        onChange={handleChange}
                        helperText={touched.address && errors.address}
                        error={Boolean(errors.address && touched.address)}
                      />
                    </MDBox>
                    <MDBox mb={3}>
                      <MDInput
                        name="password"
                        type="password"
                        label="Password"
                        variant="outlined"
                        fullWidth
                        onBlur={handleBlur}
                        value={values.password || ""}
                        onChange={handleChange}
                        helperText={touched.password && errors.password}
                        error={Boolean(errors.password && touched.password)}
                      />
                    </MDBox>
                    <MDBox mb={3}>
                      <MDInput
                        name="cpassword"
                        type="password"
                        label="Repeat Password"
                        variant="outlined"
                        fullWidth
                        onBlur={handleBlur}
                        value={values.cpassword || ""}
                        onChange={handleChange}
                        helperText={touched.cpassword && errors.cpassword}
                        error={Boolean(errors.cpassword && touched.cpassword)}
                      />
                    </MDBox>
                    <MDBox mb={4}>
                      <Divider />
                    </MDBox>
                    <MDBox mb={4}>
                      <MDInput
                        name="referral_code"
                        type="text"
                        label="Referral Code (Optional)"
                        variant="outlined"
                        fullWidth
                        value={referralCode}
                        onChange={(e) => setReferralCode(e.target.value)}
                      />
                    </MDBox>
                    <MDBox display="flex" alignItems="center" ml={-1}>
                      <Checkbox
                        onChange={(e) => {
                          setAcceptTC(e.target.checked);
                        }}
                      />
                      <MDTypography
                        variant="button"
                        fontWeight="regular"
                        color="text"
                        sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                      >
                        &nbsp;&nbsp;I accept the&nbsp;
                      </MDTypography>
                      <MDTypography
                        component="a"
                        href="https://laddar.africa/terms-conditions/"
                        variant="button"
                        fontWeight="bold"
                        color={AppConfig.sidenav_active_menu_color}
                        textGradient
                        target="_blank"
                      >
                        Terms and Conditions
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={4} mb={1}>
                      <MDButton
                        variant="gradient"
                        color={AppConfig.sidenav_active_menu_color}
                        fullWidth
                        type="submit"
                      >
                        sign up
                      </MDButton>
                    </MDBox>
                    <MDBox mt={3} mb={1} textAlign="center">
                      <MDTypography variant="button" color="text">
                        Already have an account?{" "}
                        <MDTypography
                          component={Link}
                          to="/sign-in"
                          variant="button"
                          color={AppConfig.sidenav_active_menu_color}
                          fontWeight="medium"
                          textGradient
                        >
                          Sign In
                        </MDTypography>
                      </MDTypography>
                    </MDBox>
                  </form>
                )}
              </Formik>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </BasicLayout>
  );
}

export default UserSignUp;
